import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {geoUtils} from '../utils/geo-utils';

class NationalMapShapes extends Component {

  shouldComponentUpdate(nextProps, nextState) {
    const widthDifferent = nextProps.width !== this.props.width;
    const heightDifferent = nextProps.height !== this.props.height;
    const dataDifferent = nextProps.data !== this.props.data;
    const dimXDiff = nextProps.dimX !== this.props.dimX;
    const dimYDiff = nextProps.dimY !== this.props.dimY;
    const yearDiff = nextProps.year !== this.props.year;

    return widthDifferent || heightDifferent || dataDifferent || dimXDiff || dimYDiff || yearDiff;
  }

  getScale() {
    const props = this.props;
    return geoUtils.createMultiScale(props.dict, props.dimX, props.dimY, props.year, props.type);
  }

  render() {
    const paths = geoUtils.getAlbersUsaStatePaths(this.props.width, this.props.height);
    const scale = this.getScale();

    return (
      <g className="NationalMapShapes">
        {paths.map(d => {
          return (
            <path
              key={d.id}
              d={d.path}
              fill={scale(d)}
            ></path>
          );
        })}
      </g>
    )
  }
}

NationalMapShapes.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  data: PropTypes.array,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  year: PropTypes.number,
  type: PropTypes.string
};


export default NationalMapShapes


// WEBPACK FOOTER //
// ./src/charts/NationalMap/NationalMapShapes.js